import { connect } from 'react-redux';
import { StateType } from '../../state/state.types';

const mapState = ({ layout: { userHasStartedToSearch } }: StateType) => ({
  userHasStartedToSearch,
});

export const Connect = connect(mapState);
